module.exports = __webpack_public_path__ + "static/media/storyimg.d3c5e5c5.png";